export default __webpack_public_path__ + "static/media/anthem-website-logos_toms.c814f591.webp";